angular.module('app').directive("scrollToTop", [
    '$rootScope',
    '$timeout',
    function ($rootScope, $timeout) {

    return {
        restrict: "A",
        link: function (scope, element, attributes) {
            $rootScope.$on("$stateChangeSuccess", function () {
                $timeout(function () {
                    $(element).scrollTop(0)
                })
            })
        }
    }
}
]);

angular.module('app').directive("scrollGlue", [
    '$timeout',
    function () {
        return {
            restrict: "A",
            link: function (scope, element, attributes) {
                $(attributes.srcElement).on("scroll", function () {
                    $(attributes.destElement).css("margin-top", $(attributes.srcElement).scrollTop());
                });
            }
        }
    }
]);
